<script lang="ts">
	import SkeletonSegmentControl from '$lib/components/atoms/skeleton/SkeletonSegmentControl.svelte';
	import { getDistanceSystemOptions } from '$lib/components/itinerary/tripOptions';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import SegmentControl from '$lib/components/molecules/segment-control/SegmentControl.svelte';
	import * as m from '$paraglide/messages';

	const { tripOptionsStore } = getMapLayoutContext();

	interface Props {
		loading?: boolean;
	}

	const { loading = false }: Props = $props();
</script>

{#if loading}
	<SkeletonSegmentControl
		label={m.itinerary__options__distance_unit()}
		options={getDistanceSystemOptions()}
	/>
{:else}
	<SegmentControl
		label={m.itinerary__options__distance_unit()}
		options={getDistanceSystemOptions()}
		defaultSelectedOption={$tripOptionsStore.distanceSystem}
		onSelectOption={distanceSystem => ($tripOptionsStore.distanceSystem = distanceSystem)}
	/>
{/if}
